import User from '~~/app/auth/models/User';
import Tenant from '~~/app/auth/models/Tenant';

export default (user: Pick<User, 'email' | 'locale'>, tenant: Pick<Tenant, 'getId' | 'subscriptionPlan' | 'address'>) => ({
    email: user.email,
    tenant_id: tenant.getId(),
    subscription_plan: tenant.subscriptionPlan,
    locale: user.locale,
    region: tenant.address?.province ?? null,
});
